import { HttpBackend, HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { forkJoin, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CacheService } from './cache.service';
import { LookupService } from './lookup.service';

@Injectable({
  providedIn: 'root'
})
export class APICacheService {

  constructor(private httpClient: HttpClient,
    private handler: HttpBackend,
    private cacheService: CacheService,
    private lookService: LookupService) {
    this.httpClient = new HttpClient(this.handler);
  }

  create(): Observable<any> {
    if (this.shouldFetch) {
      return this.run();
    } else {
      return this.cacheI18n(); // need to load i18n files on every reload, do something about this
    }
  }

  get shouldFetch() {
    return this.cacheService.noCacheYet ||
      this.cacheService.cacheExpired;
  }

  run(): Observable<any> {
    const cacheables = [
      this.cacheI18n(),
    ];
    return forkJoin(cacheables);
  }

  private cacheI18n() {
    const en = environment.i18nDirectory + 'en.json';
    const fr = environment.i18nDirectory + 'fr.json';
    return forkJoin([this.httpClient.get(en), this.httpClient.get(fr)]).
      pipe(
        tap((res: any) => {
          this.cacheService.en = res[0];
          this.cacheService.fr = res[1];
        }));
  }

}
